var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"share-button orange-gradient no-border mr-0 px-3",attrs:{"pill":""}},[_vm._t("default",[_vm._v(_vm._s(_vm.text ? _vm.text : _vm.$t("posts.share")))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }